import React from 'react';

const ExcelExportModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-2xl p-8 shadow-2xl max-w-md w-full mx-4 transform transition-all">
        <div className="text-center">
          {/* Animated Excel Icon */}
          <div className="mb-6 relative">
            <div className="mx-auto w-20 h-20 bg-green-100 rounded-full flex items-center justify-center animate-pulse">
              <svg className="w-12 h-12 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
              </svg>
            </div>
            {/* Animated rings */}
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-24 h-24 border-4 border-green-200 rounded-full animate-ping"></div>
            </div>
          </div>

          {/* Title */}
          <h3 className="text-2xl font-bold text-gray-900 mb-2">
            Generating Excel Report
          </h3>
          
          {/* Status messages with animation */}
          <div className="space-y-3 my-6">
            <div className="flex items-center justify-center space-x-2 text-green-600 animate-fadeIn">
              <div className="w-2 h-2 bg-green-500 rounded-full animate-bounce"></div>
              <p className="text-sm font-medium">Fetching incident data...</p>
            </div>
            
            <div className="flex items-center justify-center space-x-2 text-green-600 animate-fadeIn animation-delay-500">
              <div className="w-2 h-2 bg-green-500 rounded-full animate-bounce animation-delay-200"></div>
              <p className="text-sm font-medium">Formatting spreadsheet...</p>
            </div>
            
            <div className="flex items-center justify-center space-x-2 text-green-600 animate-fadeIn animation-delay-1000">
              <div className="w-2 h-2 bg-green-500 rounded-full animate-bounce animation-delay-400"></div>
              <p className="text-sm font-medium">Preparing download...</p>
            </div>
          </div>

          {/* Progress bar */}
          <div className="w-full bg-gray-200 rounded-full h-2 mb-6 overflow-hidden">
            <div className="bg-gradient-to-r from-green-500 to-green-600 h-2 rounded-full animate-progress"></div>
          </div>

          <p className="text-sm text-gray-500">
            Please wait while we prepare your report...
          </p>
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes progress {
          0% {
            width: 0%;
          }
          100% {
            width: 100%;
          }
        }

        .animate-fadeIn {
          animation: fadeIn 0.5s ease-out forwards;
        }

        .animation-delay-500 {
          animation-delay: 0.5s;
          opacity: 0;
        }

        .animation-delay-1000 {
          animation-delay: 1s;
          opacity: 0;
        }

        .animation-delay-200 {
          animation-delay: 0.2s;
        }

        .animation-delay-400 {
          animation-delay: 0.4s;
        }

        .animate-progress {
          animation: progress 3s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default ExcelExportModal;
